import React from 'react';
import styles from './style.module.less';
import { Layout } from 'antd';

const Header = () => {
  return <Layout.Footer className={styles.footer}>footer</Layout.Footer>;
};

export default Header;
